import { CampaignPostActionsController } from './campaign-post-actions.controller'

function campaignPostActions () {
  return {
    scope: {
      campaign: '=',
      action: '<'
    },
    restrict: 'E',
    templateUrl: '/campaigns/directives/campaign-post-actions/campaign-post-actions.html?$$REVISION$$',
    controller: CampaignPostActionsController
  }
}

export { campaignPostActions }
